import React from "react";
import { copyText } from "../lib/clipboard";
import { Button } from "../design";

export function CopyPill({
  command,
  prompt = "$",
  host,
  onCopied,
  head,
  foot,
}: {
  command: string;
  prompt?: string;
  host?: string;
  onCopied?: () => void;
  /** Turns the pill into a card: this sits beside Copy, the command gets its own line. */
  head?: React.ReactNode;
  foot?: React.ReactNode;
}) {
  const [copied, setCopied] = React.useState(false);
  const tRef = React.useRef<number | null>(null);

  const onCopy = React.useCallback(async () => {
    await copyText(command);
    setCopied(true);
    if (tRef.current) window.clearTimeout(tRef.current);
    tRef.current = window.setTimeout(() => setCopied(false), 1200);
    onCopied?.();
  }, [command, onCopied]);

  const idx = host ? command.indexOf(host) : -1;
  const text = (
    <>
      <span className="per-cmd-prompt" aria-hidden>
        {prompt}
      </span>
      <code className="per-cmd-text" title={command} onClick={onCopy}>
        {idx < 0 || !host ? (
          command
        ) : (
          <>
            {command.slice(0, idx)}
            <span className="per-cmd-host">{host}</span>
            {command.slice(idx + host.length)}
          </>
        )}
      </code>
    </>
  );
  const copy = (
    <Button
      size="sm"
      variant={head ? "secondary" : "ghost"}
      icon={copied ? "check" : "copy"}
      onClick={onCopy}
      aria-label="Copy install command"
    >
      {copied ? "Copied" : "Copy"}
    </Button>
  );

  if (!head) {
    return (
      <div className={`per-cmd${copied ? " copied" : ""}`}>
        {text}
        {copy}
      </div>
    );
  }
  return (
    <div className={`per-cmd-card${copied ? " copied" : ""}`}>
      <div className="per-cmd-head">
        {head}
        {copy}
      </div>
      <div className="per-cmd-line">{text}</div>
      {foot ? <div className="per-cmd-foot">{foot}</div> : null}
    </div>
  );
}
